import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
const imgPath = '/i3/saas_templates/shopiko/';

const BG = [
	{
		name: 'Thumble',
		img: imgPath + 'Thumble.jpg',
		href: 'https://thumble.shopiko.bg',
		tags: [
			{
				name: 'ново',
				color: '' // Example color-brand-green-500
			}
		]
	},
	{
		name: 'Smart',
		img: imgPath + 'Smart.jpg',
		href: 'https://smart.shopiko.bg'
	},
	{
		name: 'Contempo',
		img: imgPath + 'Contempo.jpg',
		href: 'https://contempo.shopiko.bg'
	},
	{
		name: 'X-Treem',
		img: imgPath + 'X-Treem.jpg',
		href: 'https://x-treem.shopiko.bg'
	},
	{
		name: 'Universal SE',
		img: imgPath + 'Universal-SE.jpg',
		href: 'https://universalse.shopiko.bg'
	}
];

///////////////////////////////////////////////////////////////////////////////////////////

const EN = [
	{
		name: 'Thumble',
		img: imgPath + 'Thumble.jpg',
		href: 'https://thumble.shopiko.bg',
		tags: [
			{
				name: 'ново',
				color: '' // Example color-brand-green-500
			}
		]
	},
	{
		name: 'Smart',
		img: imgPath + 'Smart.jpg',
		href: 'https://smart.shopiko.bg'
	},
	{
		name: 'Contempo',
		img: imgPath + 'Contempo.jpg',
		href: 'https://contempo.shopiko.bg'
	},
	{
		name: 'X-Treem',
		img: imgPath + 'X-Treem.jpg',
		href: 'https://x-treem.shopiko.bg'
	},
	{
		name: 'Universal SE',
		img: imgPath + 'Universal-SE.jpg',
		href: 'https://universalse.shopiko.bg'
	}
];

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];